import { get, isEmpty, isObject } from 'lodash';
import { FlowNode, FlowTaskState } from '../flowState';
import getSample from './getSample';
import { isTriggerStep } from 'app/beta-editor/utils/FlowUtils';

const hasSampleData = (node: FlowNode, taskState: FlowTaskState) => {
  const nodeSample = getSample(node, taskState);
  const isTrigger = isTriggerStep(node);
  const taskOutput = get(taskState, ['output', node.id]);
  const hasSamples = isTrigger
    ? isObject(taskOutput) && !isEmpty(taskOutput)
    : isObject(taskOutput);
  return nodeSample.status === 'success' && hasSamples;
};

export default hasSampleData;
